import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import QuoteIcon from "../icons/QuoteIcon";
import { MOCK_REVIEW_CAROUSEL_ITEM } from "../../constants/landingPage";

const reviews = [
  MOCK_REVIEW_CAROUSEL_ITEM,
  MOCK_REVIEW_CAROUSEL_ITEM,
  MOCK_REVIEW_CAROUSEL_ITEM,
];

const ReviewSlide = ({ review }) => (
  <div className="org-review__slide">
    <div className="org-review__image-wrap">
      <img
        src={review.course.image}
        alt={review.course.title}
        className="org-review__image"
      />
      <div className="org-review__image-overlay">
        <p className="org-review__course-title">{review.course.title}</p>
        <p className="org-review__course-tutor">{review.course.tutor.name}</p>
      </div>
    </div>
    <div className="org-review__content">
      <QuoteIcon color="#BE1622" className="org-review__quote-icon" />
      <p className="org-review__text">{review.review.text}</p>
      <div className="org-review__meta">
        <img
          src={review.review.logo}
          alt="Organization Logo"
          className="org-review__logo"
        />
        <div className="org-review__meta-text">
          <p className="org-review__position">{review.review.position}</p>
          <p className="org-review__location">{review.review.location}</p>
        </div>
      </div>
    </div>
  </div>
);

const OrganizationsReviewsCarousel = () => (
  <Swiper
    slidesPerView={1}
    spaceBetween={16}
    loop={true}
    pagination={{ clickable: true }}
    navigation={true}
    modules={[Pagination, Navigation, Autoplay]}
    autoplay={{ delay: 2000, disableOnInteraction: false }}
    className="org-review__swiper"
  >
    {reviews.map((review, idx) => (
      <SwiperSlide
        key={idx}
      >
        <ReviewSlide review={review} />
      </SwiperSlide>
    ))}
  </Swiper>
);

const OrganizationsReviews = () => (
  <div className="org-reviews">
    <div className="org-reviews__heading">
      <p className="org-reviews__title">
        أراء بعض <span className="org-reviews__title-span">المؤسسات</span>
      </p>
    </div>
    <div className="org-reviews__carousel">
      <OrganizationsReviewsCarousel />
    </div>
  </div>
);

export default OrganizationsReviews;
